<div class="pink_box"></div>
<div class="green_box"></div>

<div class="main">
  <div class="reference_table">
    <div class="top">
      <button class="top_button" (click)="addCourseOfStudy()">
        Add<em class="ti-plus"></em> 
      </button>

      <div class="right_part">
        <button class="top_button">Filter<em class="ti-filter"></em> </button>
        <div class="search">
          <input
            id="nav_search"
            class="input is-medium"
            placeholder="Search for Course Of Study"
            [formControl]="control"
            [appAutocomplete]="autocomplete"
          />
          <app-autocomplete #autocomplete="appAutocomplete">
            <ng-template appAutocompleteContent>
              <ng-container
                *ngIf="(courseOfStudies | filter: control.value) as result"
              >
                <app-option
                  *ngFor="let option of result"
                  [value]="option.CourseOfStudyName"
                >
                  {{ option.CourseOfStudyName }}
                </app-option>
                <app-option class="no-result" *ngIf="!result.length"
                  >No result...</app-option
                >
              </ng-container>
            </ng-template>
          </app-autocomplete>
          <span class="search_icon"
            ><img src="assets/images/top_nav/Magnifiction.svg" alt=""
          /></span>
        </div>
      </div>
    </div>

    <div class="custom_table_three_row">
      <form [formGroup]="courseOfStudyForm">
        <div class="thead">
          <span class="head">S/N</span>
          <span class="head">Course Of Study Name</span>
          <span class="head">Action</span>
        </div>

        <div class="tbody" formArrayName="CourseOfStudies">
          <div
            class="td"
            *ngFor="
              let courseOfStudy of courseOfStudyForm.get('CourseOfStudies')[
                'controls'
              ];
              index as i
            "
            [formGroupName]="i"
          >
            <span class="head">{{ i + 1 }}</span>
            <span
              ><input
                type="text"
                formControlName="CourseOfStudyName"
                placeholder="Enter text"
            /></span>

            <span
              ><button
                class="delete_icon trash"
                (click)="deleteCourseOfStudy(i, courseOfStudy.value)"
              >
                <em class="ti-trash"> </em> </button
            ></span>
          </div>
        </div>

        <div class="submit">
          <button
            class="submit_button"
            (click)="onSubmit(courseOfStudyForm.value)"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
